var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.24 1.494v4.747c0 .127.102.23.226.23H2.79v1.264H1.466C.658 7.735 0 7.065 0 6.241V1.494C0 .67.658 0 1.466 0h4.675A1.491 1.491 0 0 1 7.59 1.495v4.747c0 .824-.657 1.494-1.466 1.494H5.27V6.471h.853a.229.229 0 0 0 .226-.23V1.494a.227.227 0 0 0-.221-.23H1.466a.229.229 0 0 0-.226.23Zm6.814 1.771H9.55A1.491 1.491 0 0 1 11 4.76v4.746C11 10.33 10.342 11 9.533 11H4.877c-.809 0-1.467-.67-1.467-1.495V4.76c0-.824.658-1.494 1.467-1.494h.982v1.264h-.983a.229.229 0 0 0-.226.23v4.746c0 .127.102.231.227.231h4.656a.229.229 0 0 0 .227-.23V4.758a.227.227 0 0 0-.222-.23H8.054V3.265Z",
  fill: "#98A4AF"
})));
export { SvgUnion as ReactComponent };
export default __webpack_public_path__ + "74fbbd18a5ffa54ab3890c2507e15cdf.svg";